import styled from 'styled-components';

export const CashFlowsTableStyle = {
  Table: styled.table`
    background-color: #ecf1f4;
    border-collapse: separate;
    border-radius: 4px;
    border-spacing: 0;
    color: ${(props) => props.theme.algoanBlue};
    width: 100%;

    @media (max-width: 800px) {
      width: 686px;
      overflow-x: scroll;
    }
  `,
  BodyHeader: styled.tr`
    font-size: 11px;
    height: 25px;
    line-height: 13px;
    margin-top: 6px;
    text-transform: uppercase;

    th {
      background-color: rgba(127, 162, 181, 0.35);
      border-right: white 2px solid;
      font-weight: bold;
      padding: 1px 6px 1px 0;

      &:first-child {
        border-radius: 4px 0 0 4px;
        padding-left: 10px;
        border-right: white 2px solid;
        text-align: left;
      }

      &:nth-child(2) {
        max-width: 80px;
      }

      &:last-child {
        border-radius: 0 4px 4px 0;
        border-right: none;
      }
    }
  `,
};
